import { render } from "./FooterBadges.vue?vue&type=template&id=38b874f6&scoped=true"
import script from "./FooterBadges.vue?vue&type=script&lang=js"
export * from "./FooterBadges.vue?vue&type=script&lang=js"

import "./FooterBadges.vue?vue&type=style&index=0&id=38b874f6&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Github\\Wellen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b874f6"]])

export default __exports__